<template>
  <div
    class="brand-icon-box"
    :class="`variant-${variant}`"
    :style="boxStyle"
  >
    <img
      :src="logoSrc"
      class="brand-badge-img"
      :class="{ 'is-header': isHeader }"
      alt="鲸夕智绘平台"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { cdpUrl } from '@/utils/platformHelpers';

const props = defineProps({
  size: {
    type: Number,
    default: 40,
  },
  variant: {
    type: String,
    default: 'mark', // 'mark' | 'full' | 'header'
  },
});

const isFull = computed(() => props.variant === 'full');
const isHeader = computed(() => props.variant === 'header');

const FULL_LOGO_ASPECT = 2;
const HEADER_LOGO_ASPECT = 1024 / 360;
const HEADER_WIDTH_SCALE = 1.1;

const logoSrc = computed(() => {
  if (isHeader.value) {
    return `${cdpUrl('assets/brand/jingxi-logo-header.png')}?v=zhihui_v2`;
  }
  return isFull.value
    ? `${cdpUrl('assets/brand/jingxi-logo-full.png')}?v=zhihui_v2`
    : cdpUrl('assets/brand/jingxi-whale-mark.png');
});

const boxStyle = computed(() => {
  if (isHeader.value) {
    const h = props.size;
    const w = Math.round(h * HEADER_LOGO_ASPECT * HEADER_WIDTH_SCALE);
    return { height: `${h}px`, width: `${w}px` };
  }
  if (isFull.value) {
    const h = props.size;
    const w = Math.round(h * FULL_LOGO_ASPECT);
    return { height: `${h}px`, width: `${w}px` };
  }
  return { width: `${props.size}px`, height: `${props.size}px` };
});
</script>

<style scoped>
.brand-icon-box {
  background: transparent;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  overflow: visible;
  flex-shrink: 0;
  transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.brand-icon-box:hover:not(.variant-header) {
  transform: scale(1.06);
}

.brand-badge-img.is-header {
  transform: scaleX(1.06);
  transform-origin: left center;
  transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.brand-icon-box:hover .brand-badge-img.is-header {
  transform: scaleX(1.06) scale(1.05);
}

.brand-badge-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  border: none;
  outline: none;
  box-shadow: none;
}
</style>
